import { render, staticRenderFns } from "./DrawerWrapper.vue?vue&type=template&id=10c2b160"
import script from "./DrawerWrapper.vue?vue&type=script&lang=ts"
export * from "./DrawerWrapper.vue?vue&type=script&lang=ts"
import style0 from "./DrawerWrapper.vue?vue&type=style&index=0&id=10c2b160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports